<template>
  <v-container fluid>
    <v-card>
      <v-container fluid>
        <v-form :disabled="buscando" @submit.prevent="buscarVinculosSugeridosComFiltro">
          <v-row>
            <v-col cols="3" sm="3">
              <v-text-field
                v-model="filtro.itemCliente.descricao"
                label="Descrição Item Cliente"
                :loading="buscando"
              />
            </v-col>
            <v-col cols="3" sm="3">
              <v-text-field
                v-model="filtro.itemCliente.ncm"
                label="NCM Item Cliente"
                :loading="buscando"
                type="number"
              />
            </v-col>
            <v-col cols="3" sm="3">
              <v-text-field
                v-model="filtro.itemCliente.codigoBarraItemCliente"
                label="Código de Barra Cliente"
                :loading="buscando"
                type="number"
              />
            </v-col>
            <v-col cols="3" sm="3">
              <v-text-field
                v-model="filtro.itemVo.descricao"
                label="Descrição item VO"
                :loading="buscando"
              />
            </v-col>
            <v-col cols="3" sm="3">
              <v-text-field
                v-model="filtro.itemVo.ncm"
                label="NCM Item VO"
                :loading="buscando"
                type="number"
              />
            </v-col>

            <v-col cols="auto" class="d-flex align-center">
              <v-btn class="ml-4" color="primary" outlined type="submit" :loading="buscando">
                <v-icon left> mdi-magnify </v-icon>
                Pesquisar
              </v-btn>
              <v-btn
                class="ml-4"
                color="normal"
                outlined
                type="submit"
                :loading="buscando"
                @click.stop.prevent="limparSelecaoDeFiltros"
              >
                <v-icon left> mdi-autorenew </v-icon>
                Limpar
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
    </v-card>
    <v-card class="mt-4">
      <v-container fluid>
        <v-card-text>
          <center>
            <v-row>
              <v-col cols="2">
                <div>Data da última sugestão de vínculo: {{ dataUtlimaSugestao }}</div>
              </v-col>
              <v-col cols="2">
                <div>Sugestões de vínculo pendentes: {{ qtdeItensSugestao }}</div>
              </v-col>
              <v-col cols="2">
                <v-select
                  v-model="opcaoSelecionada"
                  :items="opcoesPrecisao"
                  label="Precisão Sugestão de Vínculo"
                ></v-select>
              </v-col>
              <v-col>
                <v-btn
                  class="mt-3"
                  color="primary"
                  :loading="montandoSugestoes"
                  :disabled="!permiteGerarSugestao"
                  @click="montarSugestoesVinculo"
                >
                  Gerar sugestão de vínculo
                </v-btn>
                <v-btn class="ml-2 mt-3" color="primary" :loading="buscando" @click="inicializar">
                  Atualizar
                  <v-icon> mdi-cached </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </center>
        </v-card-text>
      </v-container>
    </v-card>
    <v-card class="mt-4">
      <v-container fluid>
        <v-data-table
          :headers="headers"
          :loading="buscando"
          :items="sugestaoItens"
          :footer-props="{ itemsPerPageOptions: [5, 10, 15, 30, 50] }"
        >
          <template #[`item.codigoNcmCliente`]="{ item }">
            <span>{{ item.codigoNcmCliente }}</span>
            <v-divider />
            <span>{{ item.codigoNcmVo }}</span>
          </template>
          <template #[`item.descricaoItemCliente`]="{ item }">
            <span>{{ item.descricaoItemCliente }}</span>
            <v-divider />
            <span>{{ item.descricaoItemVo }}</span>
          </template>
          <template #[`item.codigoBarrasCliente`]="{ item }">
            <span>{{ item.codigoBarrasCliente }}</span>
            <v-divider />
            <span>{{ item.codigoBarrasVo }}</span>
          </template>
          <template #[`item.actions`]="{ item }">
            <v-row>
              <v-col class="text-center">
                <v-tooltip top>
                  <template #activator="{ on }">
                    <v-icon dark color="green" v-on="on" @click="() => abrirDialogVincular(item)">
                      mdi-check
                    </v-icon>
                  </template>
                  <span>Vincular Sugestão</span>
                </v-tooltip>
              </v-col>
              <v-col class="text-center">
                <v-tooltip top>
                  <template #activator="{ on }">
                    <v-icon dark color="red" v-on="on" @click="() => abrirDialogInvalidar(item)">
                      mdi-close
                    </v-icon>
                  </template>
                  <span>Invalidar Sugestão</span>
                </v-tooltip>
              </v-col>
            </v-row>
          </template>
        </v-data-table>

        <v-dialog v-model="vizualizarDialogInvalidar" max-width="580px">
          <v-card>
            <v-card-title class="headline"
              >Tem certeza que deseja invalidar esta sugestão?</v-card-title
            >
            <v-card-actions>
              <v-row class="mr-5" justify="end" no-gutters>
                <v-col md="auto">
                  <v-btn color="red darken-1" text @click="fecharDialog">Cancelar</v-btn>
                </v-col>
                <v-col lg="auto">
                  <v-btn color="green darken-1" text @click="invalidarSugestao">Confimar</v-btn>
                </v-col>
              </v-row>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="vizualizarDialogVincular" max-width="580px">
          <v-card>
            <v-card-title class="headline"
              >Tem certeza que deseja vincular estes itens?</v-card-title
            >
            <v-card-actions>
              <v-row class="mr-5" justify="end" no-gutters>
                <v-col md="auto">
                  <v-btn color="red darken-1" text @click="fecharDialog">Cancelar</v-btn>
                </v-col>
                <v-col lg="auto">
                  <v-btn color="green darken-1" text @click="vincularItens">Confimar</v-btn>
                </v-col>
              </v-row>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-container>
    </v-card>

    <SnackbarMessage
      :show-snack.sync="snackbar.showSnackParam"
      :snack-text="snackbar.snackTextParam"
      :snack-type="snackbar.snackTypeParam"
    />
  </v-container>
</template>

<script>
import VinculadorService from '@/services/vinculador/vinculador'
import SnackBar from '@/models/components/snackbar'
import SnackbarMessage from '@/components/SnackbarMessage'
import { formatDateTimeWithSeconds } from '@/shareds/formatacoes'
import ItemClienteService from '@/services/atualizacao/itemCliente'

export default {
  components: {
    SnackbarMessage
  },

  data: () => ({
    name: 'TelaDeVinculoItens',
    sugestaoItens: [],
    sugestaoVinculo: {},
    dataUtlimaSugestao: '-',
    qtdeItensSugestao: 0,
    opcoesPrecisao: ['25', '50', '75', '100'],
    opcaoSelecionada: '50',
    permiteGerarSugestao: true,
    headers: [
      { text: 'NCM', value: 'codigoNcmCliente', divider: true },
      { text: 'Descricao', value: 'descricaoItemCliente', divider: true },
      { text: 'Codigo de Barras', value: 'codigoBarrasCliente', divider: true },
      { text: 'Ações', value: 'actions', width: 125, sortable: false }
    ],
    filtro: {
      itemCliente: {
        codigoBarraItemCliente: null,
        descricao: null,
        ncm: null
      },
      itemVo: {
        descricao: null,
        ncm: null
      }
    },
    buscando: false,
    montandoSugestoes: false,
    snackbar: new SnackBar(),
    showDialogEdicaoParam: false,
    showDialogCriacaoParam: false,
    vizualizarDialogInvalidar: false,
    vizualizarDialogVincular: false,
    itemAcao: {}
  }),

  computed: {},

  watch: {
    vizualizarDialogInvalidar(val) {
      val || this.fecharDialog()
    },
    vizualizarDialogVincular(val) {
      val || this.fecharDialog()
    }
  },

  created() {
    this.inicializar()
  },

  methods: {
    inicializar() {
      this.buscando = true
      this.buscarVinculosSugeridos()
      this.buscando = false
    },

    async montarSugestoesVinculo() {
      this.montandoSugestoes = true
      try {
        await VinculadorService.criarSugestao(this.opcaoSelecionada)
        this.sugestaoItens = []
        this.dataUltimaSugestao = '-'
        this.qtdeItensSugestao = 0
        this.opcaoSelecionada = '50'
        this.snackbar.snackTextParam = 'Sugestões de vínculo estão sendo geradas.'
        this.snackbar.snackTypeParam = 'sucess'
        this.snackbar.showSnackParam = true
      } catch (error) {
        this.snackbar.snackTextParam = 'Ocorreu um erro ao gerar as sugestões de vínculo.'
        this.snackbar.snackTypeParam = 'error'
        this.snackbar.showSnackParam = true
      }
    },

    async buscarVinculosSugeridos() {
      try {
        const response = await VinculadorService.getAll()
        this.sugestaoVinculo = response
        if (this.sugestaoVinculo.statusProcesso === 'EXECUTADO') {
          this.sugestaoItens = this.sugestaoVinculo.sugestoesVinculo
          this.montandoSugestoes = false
          this.permiteGerarSugestao = true
          this.dataUtlimaSugestao = formatDateTimeWithSeconds(this.sugestaoVinculo.dataExecucao)
          this.qtdeItensSugestao = this.sugestaoVinculo.sugestoesVinculo.length
          this.opcaoSelecionada = this.sugestaoVinculo.precisao
        } else if (this.sugestaoVinculo.statusProcesso === 'ERRO') {
          this.montandoSugestoes = false
          this.permiteGerarSugestao = false
          this.sugestaoItens = []
          this.dataUltimaSugestao = '-'
          this.qtdeItensSugestao = 0
          this.opcaoSelecionada = '50'
          this.snackbar.snackTextParam = 'Ocorreu um erro no processamento das sugestões.'
          this.snackbar.snackTypeParam = 'error'
          this.snackbar.showSnackParam = true
        } else if (!this.sugestaoVinculo.statusProcesso) {
          this.montandoSugestoes = false
          this.permiteGerarSugestao = false
          this.sugestaoItens = []
          this.dataUltimaSugestao = '-'
          this.qtdeItensSugestao = 0
          this.opcaoSelecionada = '50'
        } else {
          this.sugestaoItens = []
          this.montandoSugestoes = true
          this.permiteGerarSugestao = false
          this.dataUltimaSugestao = '-'
          this.qtdeItensSugestao = 0
          this.opcaoSelecionada = '50'
          this.snackbar.snackTextParam =
            'Processamento das sugestões de vínculo ainda está em andamento'
          this.snackbar.snackTypeParam = 'sucess'
          this.snackbar.showSnackParam = true
        }

        this.permiteGerarSugestao = true
      } catch (error) {
        this.snackbar.snackTextParam = 'Ocorreu um erro ao buscar as sugestões.'
        this.snackbar.snackTypeParam = 'error'
        this.snackbar.showSnackParam = true
      }
    },

    async buscarVinculosSugeridosComFiltro() {
      this.buscando = true
      try {
        const response = await VinculadorService.getAll({
          descricaoItemCliente: this.filtro.itemCliente.descricao || undefined,
          ncmItemCliente: this.filtro.itemCliente.ncm || undefined,
          codigoBarraItemCliente: this.filtro.itemCliente.codigoBarraItemCliente || undefined,
          ncmItemVo: this.filtro.itemVo.ncm || undefined,
          descricaoItemVo: this.filtro.itemVo.descricao || undefined
        })
        this.sugestaoItens = response.sugestoesVinculo
      } catch (error) {
        this.snackbar.snackTextParam = 'Ocorreu um erro ao buscar as sugestões.'
        this.snackbar.snackTypeParam = 'error'
        this.snackbar.showSnackParam = true
      } finally {
        this.buscando = false
      }
    },

    async vincularItens() {
      this.buscando = true
      try {
        const itensClienteIds = new Array(this.itemAcao.itemClienteId)

        await ItemClienteService.addItemVoRelationship({
          itensClienteIds,
          itemVoId: this.itemAcao.itemVoId
        })

        await VinculadorService.removerItemSugestao(
          this.itemAcao.itemClienteId,
          this.itemAcao.itemVoId
        )

        const indice = this.sugestaoItens.indexOf(this.itemAcao)
        this.sugestaoItens.splice(indice, 1)

        this.snackbar.snackTextParam = 'Vínculo realizado com sucesso.'
        this.snackbar.snackTypeParam = 'sucess'
        this.snackbar.showSnackParam = true
      } catch (error) {
        this.snackbar.snackTextParam = error.response.data.message
        this.snackbar.snackTypeParam = 'error'
        this.snackbar.showSnackParam = true
      } finally {
        this.itemAcao = {}
        this.fecharDialog()
        this.buscando = false
      }
    },

    async invalidarSugestao() {
      this.buscando = true
      try {
        await VinculadorService.addExcecaoSugestao(
          this.itemAcao.itemClienteId,
          this.itemAcao.itemVoId
        )

        const indice = this.sugestaoItens.indexOf(this.itemAcao)
        this.sugestaoItens.splice(indice, 1)

        this.snackbar.snackTextParam = 'Sugestão de vínculo invalidada com sucesso.'
        this.snackbar.snackTypeParam = 'sucess'
        this.snackbar.showSnackParam = true
      } catch (err) {
        this.snackbar.snackTextParam = 'Ocorreu um erro ao remover sugestão.'
        this.snackbar.snackTypeParam = 'error'
        this.snackbar.showSnackParam = true
      } finally {
        this.itemAcao = {}
        this.fecharDialog()
        this.buscando = false
      }
    },

    adicionarZero(numero) {
      if (numero.toString().length > 1) {
        return numero
      }
      return '0' + numero
    },

    limparSelecaoDeFiltros() {
      this.filtro = {
        itemCliente: {
          codigoBarraItemCliente: null,
          descricao: null,
          ncm: null
        },
        itemVo: {
          descricao: null,
          ncm: null
        }
      }
    },

    abrirDialogInvalidar(item) {
      this.vizualizarDialogInvalidar = true
      this.itemAcao = item
    },

    abrirDialogVincular(item) {
      this.vizualizarDialogVincular = true
      this.itemAcao = item
    },

    fecharDialog() {
      this.vizualizarDialogVincular = false
      this.vizualizarDialogInvalidar = false
    }
  }
}
</script>

<style>
.theme--light.v-data-table tr {
  height: 70px;
}
</style>
